<div class="border border-gray-400 py-2 w-full rounded-full relative">
  <div class="absolute left-0 top-0 bottom-0 bg-primary rounded-full" [style.width]="percentLoading"></div>
</div>
